export const convertDataToApi = (data) => ({
  schoolId: data.schoolId,
  duration: data.duration.value,
  quantity: data.quantity,
  courses: data.courses,
});
